:host{display:block}.sub-table-section:last-child{padding-bottom:40px}
/*# sourceMappingURL=special-pricing-sub-table.component-O5LURUJX.css.map */
